import { setupNextraPage } from 'nextra/setup-page'
import __nextra_layout from 'nextra-theme-docs'
import __nextra_themeConfig from '/Users/changcheng/Sites/localhost/funda-ui-doc-dev/theme.config.tsx'

import 'nextra-theme-docs/style.css'
/*@jsxRuntime automatic @jsxImportSource react*/
import {useMDXComponents as _provideComponents} from "nextra/mdx";
import InitMenu from '../../src/components/InitMenu';
export const __toc = [{
  depth: 2,
  value: "Usage",
  id: "usage"
}];
function _createMdxContent(props) {
  const _components = Object.assign({
    h1: "h1",
    p: "p",
    h2: "h2",
    pre: "pre",
    code: "code",
    span: "span",
    blockquote: "blockquote"
  }, _provideComponents(), props.components);
  return <><InitMenu />{"\n"}<_components.h1>{"useSSE"}</_components.h1>{"\n"}<_components.p>{"Server-Sent Events (SSE) is a server push technology enabling a client to receive automatic updates from a server via an HTTP connection.."}</_components.p>{"\n"}<_components.h2 id="usage">{"Usage"}</_components.h2>{"\n"}<_components.pre data-language="js" data-theme="default" hasCopyCode><_components.code data-language="js" data-theme="default"><_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"import"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" useSSE "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"from"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'funda-ui/Utils/useSSE'"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"const"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"App"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" () "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"const"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" { "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"connected"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"messages"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"disconnect"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"reconnect"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" } "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"useSSE"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"("}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'http://localhost:3000/sse'"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{");"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"return"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ("}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"div"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"p"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">Status: {connected "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"?"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'✅ Connected'"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'❌ Disconnected'"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"}</"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"p"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"button"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"onClick"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{disconnect}>Disconnect</"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"button"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"button"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"onClick"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{reconnect}>Reconnect</"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"button"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        {"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"messages"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".map"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"((m"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" i) "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"div"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"key"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{i}>{m}</"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"div"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">)}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    </"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"div"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    );"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"};"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span></_components.code></_components.pre>{"\n"}<_components.blockquote>{"\n"}<_components.p>{"It is recommended to use it in conjunction with usePageVisibility, because in HTTP mode, browsers allow a maximum of 6 connections; otherwise, other normal interfaces will be suspended and inaccessible."}</_components.p>{"\n"}</_components.blockquote>{"\n"}<_components.pre data-language="js" data-theme="default" hasCopyCode><_components.code data-language="js" data-theme="default"><_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"import"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" useSSE "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"from"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'funda-ui/Utils/useSSE'"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"import"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" usePageVisibility "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"from"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'funda-ui/Utils/usePageVisibility'"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"const"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"App"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" () "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"const"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" { "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"connected"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"messages"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"disconnect"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"reconnect"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" } "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"useSSE"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"("}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'http://localhost:3000/sse'"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{");"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"// add new"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"usePageVisibility"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"("}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        () "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"reconnect"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"();"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        }"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        () "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"disconnect"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"();"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        }"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        () "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"console"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".log"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"("}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"🎬 Page initialized while visible.\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{")"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    );"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"return"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"''"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"};"}</_components.span></_components.span></_components.code></_components.pre></>;
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? <MDXLayout {...props}><_createMdxContent {...props} /></MDXLayout> : _createMdxContent(props);
}



const __nextraPageOptions = {
  MDXContent,
  pageOpts: {"filePath":"pages/Hooks/useSSE.html.mdx","route":"/Hooks/useSSE.html","timestamp":1763949985000,"pageMap":[{"kind":"Folder","name":"Applications","route":"/Applications","children":[{"kind":"Meta","data":{"collecting-data.html":"Collecting Data"}},{"kind":"MdxPage","name":"collecting-data.html","route":"/Applications/collecting-data.html"}]},{"kind":"Folder","name":"Forms","route":"/Forms","children":[{"kind":"MdxPage","name":"CascadingSelect.html","route":"/Forms/CascadingSelect.html"},{"kind":"MdxPage","name":"CascadingSelectE2E.html","route":"/Forms/CascadingSelectE2E.html"},{"kind":"MdxPage","name":"Checkbox.html","route":"/Forms/Checkbox.html"},{"kind":"MdxPage","name":"ColorPicker.html","route":"/Forms/ColorPicker.html"},{"kind":"MdxPage","name":"Date.html","route":"/Forms/Date.html"},{"kind":"MdxPage","name":"DynamicFields.html","route":"/Forms/DynamicFields.html"},{"kind":"MdxPage","name":"File.html","route":"/Forms/File.html"},{"kind":"MdxPage","name":"Input.html","route":"/Forms/Input.html"},{"kind":"MdxPage","name":"LiveSearch.html","route":"/Forms/LiveSearch.html"},{"kind":"MdxPage","name":"MultipleCheckboxes.html","route":"/Forms/MultipleCheckboxes.html"},{"kind":"MdxPage","name":"MultipleSelect.html","route":"/Forms/MultipleSelect.html"},{"kind":"MdxPage","name":"NativeSelect.html","route":"/Forms/NativeSelect.html"},{"kind":"MdxPage","name":"NumberInput.html","route":"/Forms/NumberInput.html"},{"kind":"MdxPage","name":"Radio.html","route":"/Forms/Radio.html"},{"kind":"MdxPage","name":"RangeSlider.html","route":"/Forms/RangeSlider.html"},{"kind":"MdxPage","name":"SearchBar.html","route":"/Forms/SearchBar.html"},{"kind":"MdxPage","name":"Select.html","route":"/Forms/Select.html"},{"kind":"MdxPage","name":"Switch.html","route":"/Forms/Switch.html"},{"kind":"MdxPage","name":"TagInput.html","route":"/Forms/TagInput.html"},{"kind":"MdxPage","name":"Textarea.html","route":"/Forms/Textarea.html"},{"kind":"Meta","data":{"CascadingSelect.html":"Cascading Select","CascadingSelectE2E.html":"Cascading Select End-to-end 🔥","Checkbox.html":"Checkbox","ColorPicker.html":"Color Picker","Date.html":"Date 🔥","DynamicFields.html":"Dynamic Fields 🔥","File.html":"File","Input.html":"Input 🤖","LiveSearch.html":"Live Search","MultipleCheckboxes.html":"Multiple Checkboxes","MultipleSelect.html":"Multiple Select 🔥","NativeSelect.html":"Native Select","NumberInput.html":"Number Input","Radio.html":"Radio","RangeSlider.html":"Range Slider","SearchBar.html":"Search Bar","Select.html":"Select 🔥","Switch.html":"Switch","TagInput.html":"Tag Input","Textarea.html":"Textarea 🤖"}}]},{"kind":"Folder","name":"Getting-Started","route":"/Getting-Started","children":[{"kind":"MdxPage","name":"Installation.html","route":"/Getting-Started/Installation.html"},{"kind":"MdxPage","name":"Usage.html","route":"/Getting-Started/Usage.html"},{"kind":"Meta","data":{"Installation.html":"Installation","Usage.html":"Usage"}}]},{"kind":"Folder","name":"Hooks","route":"/Hooks","children":[{"kind":"Meta","data":{"useKeyPress.html":"useKeyPress","usePageVisibility.html":"usePageVisibility","useThrottle.html":"useThrottle","useDebounce.html":"useDebounce","useComId.html":"useComId","useInterval.html":"useInterval","useWindowScroll.html":"useWindowScroll","useAutosizeTextArea.html":"useAutosizeTextArea","useClickOutside.html":"useClickOutside","useDraggable.html":"useDraggable","useBoundedDrag.html":"useBoundedDrag","useStreamController.html":"useStreamController","useHistoryTracker.html":"useHistoryTracker","useSSE.html":"useSSE"}},{"kind":"MdxPage","name":"useAutosizeTextArea.html","route":"/Hooks/useAutosizeTextArea.html"},{"kind":"MdxPage","name":"useBoundedDrag.html","route":"/Hooks/useBoundedDrag.html"},{"kind":"MdxPage","name":"useClickOutside.html","route":"/Hooks/useClickOutside.html"},{"kind":"MdxPage","name":"useComId.html","route":"/Hooks/useComId.html"},{"kind":"MdxPage","name":"useDebounce.html","route":"/Hooks/useDebounce.html"},{"kind":"MdxPage","name":"useDraggable.html","route":"/Hooks/useDraggable.html"},{"kind":"MdxPage","name":"useHistoryTracker.html","route":"/Hooks/useHistoryTracker.html"},{"kind":"MdxPage","name":"useInterval.html","route":"/Hooks/useInterval.html"},{"kind":"MdxPage","name":"useKeyPress.html","route":"/Hooks/useKeyPress.html"},{"kind":"MdxPage","name":"usePageVisibility.html","route":"/Hooks/usePageVisibility.html"},{"kind":"MdxPage","name":"useSSE.html","route":"/Hooks/useSSE.html"},{"kind":"MdxPage","name":"useStreamController.html","route":"/Hooks/useStreamController.html"},{"kind":"MdxPage","name":"useThrottle.html","route":"/Hooks/useThrottle.html"},{"kind":"MdxPage","name":"useWindowScroll.html","route":"/Hooks/useWindowScroll.html"}]},{"kind":"Folder","name":"Interaction","route":"/Interaction","children":[{"kind":"MdxPage","name":"DragDropList.html","route":"/Interaction/DragDropList.html"},{"kind":"MdxPage","name":"HorizontalScrollContent.html","route":"/Interaction/HorizontalScrollContent.html"},{"kind":"MdxPage","name":"ModeSwitch.html","route":"/Interaction/ModeSwitch.html"},{"kind":"MdxPage","name":"Refresher.html","route":"/Interaction/Refresher.html"},{"kind":"MdxPage","name":"ScrollReveal.html","route":"/Interaction/ScrollReveal.html"},{"kind":"MdxPage","name":"Scrollbar.html","route":"/Interaction/Scrollbar.html"},{"kind":"Meta","data":{"DragDropList.html":"DragDrop List 🔥","HorizontalScrollContent.html":"Horizontal Scroll Content","ModeSwitch.html":"Mode Switch","Refresher.html":"Refresher","Scrollbar.html":"Custom Scrollbar","ScrollReveal.html":"Scroll Reveal"}}]},{"kind":"Folder","name":"Layouts","route":"/Layouts","children":[{"kind":"MdxPage","name":"MasonryLayout.html","route":"/Layouts/MasonryLayout.html"},{"kind":"MdxPage","name":"RootPortal.html","route":"/Layouts/RootPortal.html"},{"kind":"MdxPage","name":"SplitterPanel.html","route":"/Layouts/SplitterPanel.html"},{"kind":"Meta","data":{"MasonryLayout.html":"Masonry Layout","RootPortal.html":"Root Portal","SplitterPanel.html":"Splitter Panel"}}]},{"kind":"Folder","name":"Navigation","route":"/Navigation","children":[{"kind":"MdxPage","name":"DropdownMenu.html","route":"/Navigation/DropdownMenu.html"},{"kind":"MdxPage","name":"MultilevelDropdownMenu.html","route":"/Navigation/MultilevelDropdownMenu.html"},{"kind":"Meta","data":{"DropdownMenu.html":"Dropdown Menu","MultilevelDropdownMenu.html":"Multilevel Dropdown Menu"}}]},{"kind":"Folder","name":"Web-Elements","route":"/Web-Elements","children":[{"kind":"MdxPage","name":"Accordion.html","route":"/Web-Elements/Accordion.html"},{"kind":"MdxPage","name":"BackToTop.html","route":"/Web-Elements/BackToTop.html"},{"kind":"MdxPage","name":"Chatbox.html","route":"/Web-Elements/Chatbox.html"},{"kind":"MdxPage","name":"DigitalClock.html","route":"/Web-Elements/DigitalClock.html"},{"kind":"MdxPage","name":"EventCalendar.html","route":"/Web-Elements/EventCalendar.html"},{"kind":"MdxPage","name":"EventCalendarTimeline.html","route":"/Web-Elements/EventCalendarTimeline.html"},{"kind":"MdxPage","name":"ModalDialog.html","route":"/Web-Elements/ModalDialog.html"},{"kind":"MdxPage","name":"Pagination.html","route":"/Web-Elements/Pagination.html"},{"kind":"MdxPage","name":"Popover.html","route":"/Web-Elements/Popover.html"},{"kind":"MdxPage","name":"ShowMoreLess.html","route":"/Web-Elements/ShowMoreLess.html"},{"kind":"MdxPage","name":"Stepper.html","route":"/Web-Elements/Stepper.html"},{"kind":"MdxPage","name":"Table.html","route":"/Web-Elements/Table.html"},{"kind":"MdxPage","name":"Tabs.html","route":"/Web-Elements/Tabs.html"},{"kind":"MdxPage","name":"Toast.html","route":"/Web-Elements/Toast.html"},{"kind":"MdxPage","name":"Tooltip.html","route":"/Web-Elements/Tooltip.html"},{"kind":"MdxPage","name":"Tree.html","route":"/Web-Elements/Tree.html"},{"kind":"Meta","data":{"Accordion.html":"Accordion","BackToTop.html":"Back To Top","Chatbox.html":"Chatbox 🔥🤖","DigitalClock.html":"Digital Clock","EventCalendar.html":"Event Calendar 🔥","EventCalendarTimeline.html":"Event Calendar Timeline 🔥","ModalDialog.html":"Modal Dialog 🔥","Popover.html":"Popover 🔥","Pagination.html":"Pagination","ShowMoreLess.html":"Show More Less","Stepper.html":"Stepper","Table.html":"Table 🔥","Tabs.html":"Tabs","Toast.html":"Toast","Tooltip.html":"Tooltip","Tree.html":"Tree 🔥"}}]},{"kind":"Meta","data":{"index":"Introduction","Getting-Started":"","---":{"type":"separator","title":"Components"},"Applications":"","Forms":"","Web-Elements":"","Navigation":"","Interaction":"","Layouts":"","contact":{"title":"Source ↗","type":"page","href":"https://github.com/xizon/funda-ui","newWindow":true}}},{"kind":"MdxPage","name":"index","route":"/"}],"flexsearch":{"codeblocks":true},"title":"useSSE",headings:__toc},
  pageNextRoute: "/Hooks/useSSE.html",
  nextraLayout: __nextra_layout,themeConfig: __nextra_themeConfig
}
if (process.env.NODE_ENV !== 'production') {
  __nextraPageOptions.hot = module.hot
  __nextraPageOptions.pageOptsChecksum = ''
}
if (typeof window === 'undefined') __nextraPageOptions.dynamicMetaModules = []

export default setupNextraPage(__nextraPageOptions)